var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('b-button',{staticClass:"back-to-top",attrs:{"variant":"primary"},on:{"click":function($event){return _vm.$emit('scrollToTop')}}},[_c('b-icon',{attrs:{"icon":"arrow-up"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }